import { render, staticRenderFns } from "./age.vue?vue&type=template&id=6b4ed45f&scoped=true&"
import script from "./age.vue?vue&type=script&lang=js&"
export * from "./age.vue?vue&type=script&lang=js&"
import style0 from "./age.vue?vue&type=style&index=0&id=6b4ed45f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ed45f",
  null
  
)

export default component.exports